export const C = {
  turquesa: '#5dc1b9',
  mango: '#FDBE02',
  coral: '#eb636b',
  logoGrad: 'linear-gradient(135deg, #534AB7, #1D9E75)',
  triGrad: 'linear-gradient(135deg, #5dc1b9, #FDBE02, #eb636b)',
  dark: '#0a0a0a',
  gray: '#555',
  lightGray: '#999',
  border: 'rgba(255,255,255,0.1)',
};

export const font = "'DM Sans', sans-serif";
export const serif = "'DM Serif Display', serif";

const isMob = typeof window !== 'undefined' && window.innerWidth < 768;

export const glassCard = {
  background: 'rgba(255,255,255,0.05)',
  backdropFilter: isMob ? 'blur(15px)' : 'blur(30px)',
  WebkitBackdropFilter: isMob ? 'blur(15px)' : 'blur(30px)',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: 24,
};

export const btnStyle = {
  background: 'linear-gradient(135deg, #534AB7, #1D9E75, #534AB7)',
  color: '#fff',
  border: 'none',
  borderRadius: 50,
  fontFamily: font,
  cursor: 'pointer',
  fontWeight: 500,
  boxShadow: '0 0 40px rgba(93,193,185,0.4), 0 0 80px rgba(93,193,185,0.15)',
  transition: 'transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s, background 0.3s',
  backgroundSize: '200% auto',
  animation: 'shimmer 3s linear infinite',
};

export const btnHoverEnter = e => {
  e.currentTarget.style.transform = 'translateY(-3px) scale(1.03)';
  e.currentTarget.style.boxShadow = '0 0 60px rgba(93,193,185,0.6), 0 0 120px rgba(93,193,185,0.25)';
};
export const btnHoverLeave = e => {
  e.currentTarget.style.transform = 'translateY(0) scale(1)';
  e.currentTarget.style.boxShadow = '0 0 40px rgba(93,193,185,0.4), 0 0 80px rgba(93,193,185,0.15)';
};
